import { render } from "./StakingHealthcheck.vue?vue&type=template&id=45913920"
import script from "./StakingHealthcheck.vue?vue&type=script&lang=js"
export * from "./StakingHealthcheck.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakingHealthcheck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45913920"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45913920', __exports__)) {
    api.reload('45913920', __exports__)
  }
  
  module.hot.accept("./StakingHealthcheck.vue?vue&type=template&id=45913920", () => {
    api.rerender('45913920', render)
  })

}


export default __exports__